import React, { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import CompletionPopup from '../completion-popup';
import { serverURL } from '../../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';

export function DeclareVariables() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        startConfetti
    } = useCareerContext();
    const options = { scrollbar: { alwaysConsumeMouseWheel: false, }, scrollBeyondLastLine: false, minimap: { enabled: false, } }

    const [code, setCode] = useState("# Write code here\n");
    const [output, setOutput] = useState('');

    function handleEditorChange(newValue, event) {
        setCode(newValue);
    }

    async function runCode() {
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        };
        const response = await fetch(serverURL + "/declare_variables", requestOptions);
        const result = await response.json();
        if (result.error) {
            setOutput(result.error);
        } else if (result.verdict === "Fail") {
            setOutput(result.message)
        } else {
            setOutput("");
            setIsPopupOpen(true);
            startConfetti();
        }
    }

    function hidePopup() {
        setIsPopupOpen(false);
    }


    return (
        <>
            {isPopupOpen && <CompletionPopup title="Great Job!" message="Great job, you nailed it! You really know your variables and data types!" hidePopup={hidePopup} />}

            <h2 className='blue'>Building a Social Media App</h2>
            <p>You have just been recruited as a SWE to Connect, an up and coming social media platform. Your task is to store the data of the users. Declare variables <code>first_name</code>, <code>age</code>, <code>is_account_verified</code>, and <code>followers</code> for 30 year old Denzel, who is verified and has 93 followers. Choose your data types wisely!</p>

            <div className='row' style={{ alignItems: "flex-start" }}>
                <div style={{ width: (output) ? "50%" : "100%" }}>
                    <div className='editor-padding'></div>
                    <MonacoEditor theme='vs-dark' language='python' height="150px" value={code} onChange={handleEditorChange} options={options} />
                    <button className='primary-btn blue-bg' style={{ marginTop: "5px" }} onClick={runCode}>Submit</button>
                </div>
                
                {output && <pre className='output' style={{ height: "150px" }}>{output}</pre>}

            </div>
        </>
    );
}
